import FileDownload from "js-file-download"
import { push } from "redux-first-history"
import { all, call, delay, put, select } from "redux-saga/effects"

import AuthActions, { AuthSelectors } from "../Containers/LoginPage/reducer"
import UserActions from "../Containers/User/reducer"
import ErrorsActions from "../Redux/ErrorsRedux"
import utils from "./utils"

export function* apiGeneratorBase(action, provider) {
  try {
    let params = action.payload
    let onSuccess, onError, notRedirect, skipExtraAction

    if (
      params &&
      (params?.onSuccess || params?.onError || params?.notRedirect || params?.skipExtraAction)
    ) {
      ;({ onSuccess, onError, notRedirect, skipExtraAction, ...params } = params)
    }
    const response = yield call(provider.api, params)
    const test_data = yield select((state) => state.globalFilters.testData)

    const disposition = response?.headers?.["content-disposition"]
    let originalName = ""
    if (disposition && disposition.includes("filename=")) {
      originalName = disposition.split("filename=")[1].split(";")[0].replace(/['"]/g, "")
    }

    if (response.ok && response.data) {
      if (provider.actions.message) {
        yield put(
          provider.actions.success({
            message: provider.actions.message,
            ...response.data
          })
        )
      } else if (provider.actions.downloadFile) {
        let fileName = originalName
        if (!originalName) {
          fileName = `${params?.file_name || "Report"}${params?.format || ".csv"}`
        }
        FileDownload(response.data, fileName)
        yield put(provider.actions.success(true))
      } else {
        yield put(provider.actions.success(response.data))
        const hasExternalRedirect = Boolean(response.data?.redirect_url)

        if (hasExternalRedirect && !notRedirect) utils.goLink(response.data?.redirect_url)

        if (provider.actions.redirect && !hasExternalRedirect && !notRedirect) {
          yield put(push(provider.actions.redirect))
        }
      }
      if (
        provider.actions.redirect &&
        !response.data?.redirect_url &&
        (provider.actions.message || provider.actions.downloadFile)
      ) {
        yield put(push(provider.actions.redirect))
      }
      if (provider.actions?.extraAction && !skipExtraAction) {
        // yield all(provider.actions?.extraAction.map(action => put(action())));
        yield all(
          provider.actions.extraAction.map((actionCreator) => {
            const tempAction = actionCreator()
            const actionType = tempAction.type

            if (actionType === "GET_STATISTICS_ADMIN_REQUEST") {
              return put(
                actionCreator({
                  test_data
                })
              )
            }
            return put(actionCreator())
          })
        )
      }

      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(response.data)
      }
    } else if (response.ok && (response.status === 201 || response.status === 204)) {
      yield put(provider.actions.success(params))
      if (provider.actions.redirect) yield put(push(provider.actions.redirect))
      if (provider.actions?.extraAction && !skipExtraAction) {
        // yield all(provider.actions?.extraAction.map(action => put(action())));
        yield all(
          provider.actions.extraAction.map((actionCreator) => {
            const tempAction = actionCreator()
            const actionType = tempAction.type

            if (actionType === "GET_STATISTICS_ADMIN_REQUEST") {
              return put(
                actionCreator({
                  test_data
                })
              )
            }
            return put(actionCreator())
          })
        )
      }
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(response.data)
      }
    } else {
      yield put(
        provider.actions.errors(
          response.data?.message?.detail || response.data?.message || response.data?.detail?.[0]
        )
      )
      if (provider.actions.withoutErrorNotification) {
      } else {
        let error = response.data
        if (response.data instanceof Blob) {
          const text = yield call([response.data, response.data.text])
          error = JSON.parse(text)
        }
        yield put(
          ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error)
        )
      }
      if (onError && typeof onError === "function") {
        onError(response.data)
      }
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export function* apiGeneratorBaseWithOnSuccess(action, provider) {
  try {
    const params = action.payload
    const { onSuccess, ...requestParams } = params
    const response = yield call(provider.api, requestParams)
    const test_data = yield select((state) => state.globalFilters.testData)

    if (response.ok && response.data) {
      if (provider.actions.message) {
        yield put(
          provider.actions.success({
            message: provider.actions.message,
            ...response.data
          })
        )
      } else {
        yield put(provider.actions.success(response.data))
        if (response.data?.redirect_url) utils.goLink(response.data?.redirect_url)
      }
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    } else if (response.ok && (response.status === 201 || response.status === 204)) {
      yield put(provider.actions.success(requestParams))
    } else {
      yield put(
        provider.actions.errors(
          response.data?.message?.detail || response.data?.message || response.data?.detail?.[0]
        )
      )
      if (provider.actions.withoutErrorNotification) {
      } else {
        let error = response.data
        if (response.data instanceof Blob) {
          const text = yield call([response.data, response.data.text])
          error = JSON.parse(text)
        }
        yield put(
          ErrorsActions.errorSave(response.status === 500 ? "Server response error" : error)
        )
      }
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export function* apiGeneratorDelete(action, provider) {
  const userInfo = yield select(AuthSelectors.getUserInfo)
  const test_data = yield select((state) => state.globalFilters.testData)
  try {
    let params = action.payload
    let onSuccess, onError

    if (params && (params?.onSuccess || params?.onError)) {
      ;({ onSuccess, onError, ...params } = params)
    }

    const response = yield call(provider.api, params)
    if ((response.ok && response.data) || response.status === 204) {
      if (action.type === "DELETE_BUSINESS_ACCOUNT_REQUEST") {
        if (provider.actions?.extraAction)
          yield all(provider.actions?.extraAction.map((action) => put(action())))
        if (provider.actions.redirect) yield put(push(provider.actions.redirect))
        yield put(
          provider.actions.success({
            id: params,
            message: response.data?.message?.detail || response.data?.message
          })
        )

        if (
          userInfo.last_used_business_account_id !== null &&
          userInfo.last_used_business_account_id !== userInfo.current_business_account_id
        ) {
          yield put(
            UserActions.userSaveRequest({
              current_business_account_id: userInfo.last_used_business_account_id
            })
          )
          yield put(
            AuthActions.updateProfile({
              current_business_account_id: userInfo.last_used_business_account_id
            })
          )
        }
      } else {
        //yield delay(600);
        yield put(
          provider.actions.success({
            id: params,
            message: response.data?.message?.detail || response.data?.message
          })
        )
        if (provider.actions.redirect) yield put(push(provider.actions.redirect))
        if (provider.actions?.extraAction) {
          // yield all(provider.actions?.extraAction.map(action => put(action())));
          yield all(
            provider.actions.extraAction.map((actionCreator) => {
              const tempAction = actionCreator()
              const actionType = tempAction.type

              if (actionType === "GET_STATISTICS_ADMIN_REQUEST") {
                return put(
                  actionCreator({
                    test_data
                  })
                )
              }
              return put(actionCreator())
            })
          )
        }
      }
      if (onSuccess && typeof onSuccess === "function") {
        onSuccess(response.data)
      }
    } else {
      yield put(provider.actions.errors())
      yield put(
        ErrorsActions.errorSave(response.status === 500 ? "Server response error" : response.data)
      )
      if (onError && typeof onError === "function") {
        onError(response.data)
      }
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export function* apiGeneratorDeleteWithOnSuccess(action, provider) {
  try {
    const params = action.payload
    const { onSuccess, ...requestParams } = params
    const response = yield call(provider.api, requestParams)
    if (response.ok && (response.data || response.status === 204)) {
      yield put(
        provider.actions.success({
          id: requestParams,
          message: response.data?.message?.detail || response.data?.message
        })
      )

      if (onSuccess && typeof onSuccess === "function") {
        onSuccess()
      }
    } else {
      yield put(provider.actions.errors())
      yield put(
        ErrorsActions.errorSave(response.status === 500 ? "Server response error" : response.data)
      )
    }
  } catch (errors) {
    yield put(provider.actions.errors())
    yield put(ErrorsActions.errorSave({ errors }))
  }
}

export function* apiGeneratorFake(action, provider) {
  try {
    const params = action.payload
    yield delay(700)
    let data = null
    if (provider.actions["fakeData"]) {
      data = provider.actions["fakeData"]
    } else if (provider.actions["isDelete"]) {
      data = { id: params }
    } else {
      if (provider.actions.message) {
        data = {
          message: provider.actions.message,
          data: params
        }
      } else {
        data = params
      }
    }
    yield put(provider.actions.success(data))
    if (provider.actions?.extraAction) yield put(provider.actions.extraAction())
  } catch (errors) {
    yield put(provider.actions.errors({ errors }))
  }
}
